export enum SORT_TYPE {
  ASC = "ASC",
  DESC = "DESC",
}
